// this file added by Bearer Web Developer - change map api
import { useMap, useApiIsLoaded } from "@vis.gl/react-google-maps";
import { useEffect } from "react";

function Polyline(props: google.maps.PolylineOptions) {
    const map = useMap();
    const apiIsLoaded = useApiIsLoaded();
    useEffect(() => {
        if (!map || !apiIsLoaded) return;
        const polyline = new google.maps.Polyline({
            ...props,
            map: map // The poly adds to the map ,
        });
        return () => {
            polyline.setMap(null);
        };
    }, [map, apiIsLoaded, props?.path]);
    return null;
}
export default Polyline;
